import React from 'react';

const CustomText = ({ text, size = 'text-base', color = 'gray-800', weight = 'normal', className = '', ...props }) => {
    const textSize = {
        small: 'text-sm',
        base: 'text-base',
        large: 'text-lg',
        xl: 'text-xl',
        '2xl': 'text-2xl',
        '3xl': 'text-3xl',
    };

    const textWeight = {
        normal: 'font-normal',
        bold: 'font-bold',
        semibold: 'font-semibold',
        light: 'font-light',
    };

    return (
        <p
            className={`text-${color} ${textSize[size]} ${textWeight[weight]} ${className} text-center`}
            {...props}
        >
            {text}
        </p>
    );
};

export default CustomText;
